import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { useRunResultPickerItems } from "@certn/monitoring";

export function MonitoringResultFilter() {
  const { clearParam, setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const options = useRunResultPickerItems();

  return (
    <Picker
      label={t("Overall result")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.overall_result?.split(",") || []}
      onSelectionChange={(keys) => {
        clearParam("page");
        setParam("overall_result", Array.from(keys));
      }}
      items={options}
      testID="monitoring-result-filter-picker"
    />
  );
}
